export const AGENCY_SITE_URL = 'https://travelatapro.ru';
export const AGENCY_FRANCHISING_URL = `${AGENCY_SITE_URL}/franchising`;
